import {Suspense} from "react";
import {Helmet} from "react-helmet-async";
import {Navigate, useSearchParams} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {TagsActionBar} from "@/pages/tags/list/TagsActionBar.tsx";
import {TagsList} from "@/pages/tags/list/TagsList.tsx";
import {normalizeLegacyTagsListParams} from "@/pages/tags/list/TagsPage.utils.ts";

export const TagsPage = () => {
  const {user} = useCurrentUserContext();
  const [searchParams] = useSearchParams();
  // Rewritten before TagsList mounts, so useTable reads the search on its first render.
  const legacyRedirectSearch = normalizeLegacyTagsListParams(searchParams)?.toString();
  return (
    <ContentContainer actionsBar={user?.has_write_access && <TagsActionBar />} title="Tags">
      <Helmet>
        <title>Tags</title>
      </Helmet>
      <Suspense>
        <UpErrorBoundary>
          {legacyRedirectSearch === undefined ? <TagsList /> : <Navigate replace to={{search: legacyRedirectSearch}} />}
        </UpErrorBoundary>
      </Suspense>
    </ContentContainer>
  );
};
